import { Box, Chip, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Checkbox, ListItemText } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { i18n } from "../../translate/i18n";

// Unified filter pill — neutral hairline + subtle brand-green hover.
// Was wearing an indigo/violet tint that clashed with the brand-green
// dark theme.
const useStyles = makeStyles((theme) => {
	const isDark = theme.palette.type === "dark";
	return {
		selectButton: {
			backgroundColor: isDark ? "#131614" : "#fff",
			borderRadius: 10,
			transition: "border-color 0.18s ease, background-color 0.18s ease",
			"&:hover": {
				backgroundColor: isDark
					? "rgba(46, 227, 122, 0.06)"
					: "rgba(37, 211, 102, 0.06)",
			},
			"& .MuiSelect-outlined": {
				paddingTop: 8,
				paddingBottom: 8,
				paddingLeft: 14,
				paddingRight: 32,
				fontSize: 13,
				fontWeight: 600,
				color: isDark ? "#e4e4e7" : "#0f172a",
			},
			"& .MuiSelect-icon": {
				color: isDark ? "#a8acb3" : "#64748b",
			},
			"& .MuiOutlinedInput-notchedOutline": {
				borderWidth: 1,
				borderColor: isDark
					? "rgba(255, 255, 255, 0.07)"
					: "#eaeaea",
			},
			"&:hover .MuiOutlinedInput-notchedOutline": {
				borderColor: isDark
					? "rgba(46, 227, 122, 0.4)"
					: "#86efac",
			},
		},
	};
});
export function TagsFilter({ onFiltered }) {
  const classes = useStyles();
  const { t } = useTranslation();

  const [tags, setTags] = useState([]);
  const [selecteds, setSelecteds] = useState([]);

  useEffect(() => {
    async function fetchData() {
      await loadTags();
    }
    fetchData();
  }, []);

  const loadTags = async () => {
    try {
      const { data } = await api.get(`/tags/list`);
      setTags(data);
    } catch (err) {
      toastError(err);
    }
  };

  const handleChange = (event) => {
    const { value } = event.target;
    setSelecteds(value);
    onFiltered(value);
  };

  return (
    <Box style={{ paddingRight: 5 }}>
        <FormControl fullWidth margin="dense">
          <Select
          className={classes.selectButton}
            multiple
            displayEmpty
            variant="outlined"
            value={selecteds}
            onChange={handleChange}
            MenuProps={{
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
              },
              transformOrigin: {
                vertical: "top",
                horizontal: "left",
              },
              getContentAnchorEl: null,
            }}
            renderValue={(selected) => {
              // if (selected.length === 0) {
                return <em>{t("mainDrawer.listItems.tags")}</em>;
              // }
              // return selected.map((id) => tags.find((tag) => tag.id === id).name).join(", ");
            }}
          >
            {tags.length > 0 &&
              tags.map((tag) => (
                <MenuItem key={tag.id} value={tag.id}>
                  <Checkbox
                    style={{
                      color: tag.color,
                    }}
                    size="small"
                    color="primary"
                    checked={selecteds.indexOf(tag.id) > -1}
                  />
                  <ListItemText primary={tag.name} />
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </Box>
  );
}
